import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-roulette-new-round-preparation',
    imports: [CommonModule],
    templateUrl: './new-round-preparation.component.html',
    styleUrl: './new-round-preparation.component.scss'
})
export class RouletteNewRoundPreparationComponent {}
